"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsTracker = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var AnalyticsTracker = (function () {
    function AnalyticsTracker() {
        this.providers = new Set();
        this._useFb = true;
    }
    AnalyticsTracker.prototype.init = function () {
        var analyticsConfig = core_1.di.get(interfaces_1.TypesCore.gameConfig).analytics;
        if (analyticsConfig) {
            var fb = analyticsConfig.fb, firebaseConf = analyticsConfig.firebase;
            if (firebaseConf) {
            }
            if (typeof fb === "boolean") {
                this._useFb = fb;
            }
        }
    };
    AnalyticsTracker.prototype.addProvider = function (tracker) {
        this.providers.add(tracker);
    };
    AnalyticsTracker.prototype.removeProvider = function (tracker) {
        this.providers.delete(tracker);
    };
    AnalyticsTracker.prototype.track = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _a = tslib_1.__read(params, 3), name = _a[0], value = _a[1], p = _a[2];
        if (typeof value === "object") {
            p = value;
            value = 0;
        }
        value || (value = 0);
        if (name) {
            this.providers.forEach(function (provider) { return provider.track(name, value, p); });
        }
    };
    AnalyticsTracker = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], AnalyticsTracker);
    return AnalyticsTracker;
}());
exports.AnalyticsTracker = AnalyticsTracker;
//# sourceMappingURL=AnalyticsTracker.js.map